import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M9 0a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9m0 2c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7m-.104 9.95q.477 0 .783.291a.98.98 0 0 1 .306.74.97.97 0 0 1-.3.73q-.297.289-.79.29-.49-.001-.788-.29a.97.97 0 0 1-.3-.73.98.98 0 0 1 .307-.74q.305-.29.782-.29M9.03 4q1.424 0 2.21.69.787.69.787 1.946 0 .572-.255 1.08-.257.509-.895 1.126l-.544.52q-.51.49-.585 1.15l-.026.41H8.002q0-.943.229-1.5.227-.56.837-1.1.608-.542.809-.882t.202-.717q0-1.137-1.048-1.138-.497 0-.797.307-.299.306-.313.845H5.973q.013-1.285.83-2.01Q7.619 4 9.03 4"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="currentColor" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
